<template>
  <v-form
    ref="form"
    :value="valid"
    @input="v => $emit('update:valid', v)"
    @submit.prevent
  >
    <v-row align="center" dense>
      <v-col cols="12" sm="6">
        <v-text-field
          :value="name"
          @change="v => $emit('update:name', v)"
          label="Nom du gabarit"
          :rules="[
            v => !!v || 'Un nom est requis',
            v => v !== '' || 'Un nom est requis'
          ]"
          filled
          class="no-before"
          single-line
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          filled
          label="Fournisseur"
          :items="getSuppliers"
          item-value="id_fournisseur"
          item-text="name_fournisseur"
          :value="supplier"
          @click:clear="() => $emit('update:supplier', null)"
          @change="v => $emit('update:supplier', v)"
          prepend-inner-icon="fa-building"
          class="no-before"
          dense
          single-line
          :rules="[
            v => !!v || 'Un fournisseur est requis',
            v => v !== null || 'Un fournisseur est requis'
          ]"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row align="center" dense>
      <v-col cols="12" sm="6">
        <j-decimal-input
          filled
          class="no-before"
          suffix="$"
          label="Montant à utiliser pour les quantités variables"
          hint="Laisser vide pour ignorer"
          persistent-hint
          :value="sales_target"
          @input="v => $emit('update:sales_target', v > 0 ? v : null)"
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="6" v-show="sales_target !== null">
        <j-decimal-input
          filled
          class="no-before"
          label="Nombre de jour par défaut entre chaque commande"
          hint="Laisser vide pour ignorer"
          persistent-hint
          :value="default_number_of_days"
          @input="v => $emit('update:default_number_of_days', v > 0 ? v : null)"
        ></j-decimal-input>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OrderTemplateFields",
  props: {
    name: {
      type: String,
      required: true
    },
    supplier: {
      required: true
    },
    sales_target: {
      required: true
    },
    default_number_of_days: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getSuppliers"])
  }
};
</script>

<style></style>
